import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import BlogLayout from "../../../components/BlogLayout";
import "./AskVijay.css";

const AskVijay = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const mockBlog = {
          title: "கேள்வி கேள்!",
          subtitle: "விஜயிடம் கேள்வி கேள்! த.வெ.க-விடம் கேள்வி கேள்!",
          publishDate: "February 9, 2026",
          content: "",
        };
        setBlog(mockBlog);
      } catch (error) {
        console.error("Error fetching blog:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlog();
  }, [slug]);

  if (loading) {
    return (
      <BlogLayout title="Loading...">
        <div className="loading-container">
          <div className="loading-spinner"></div>
        </div>
      </BlogLayout>
    );
  }

  if (!blog) {
    return (
      <BlogLayout title="Error">
        <div className="error-container">
          <h2 className="error-title">Blog post not found</h2>
          <p className="error-message">
            The requested blog post could not be loaded.
          </p>
        </div>
      </BlogLayout>
    );
  }

  return (
    <BlogLayout title={blog.title} customClass="blog-header">
      <Helmet>
        <title>கேள்வி கேள்!விஜயிடம் கேள்வி கேள்!</title>
        <meta
          name="description"
          content="கேள்வி கேள்!விஜயிடம் கேள்வி கேள்! த.வெ.க-விடம் கேள்வி கேள்!கேள்வி கேட்கும் உரிமை உன்னிடம் முழுமையாக உள்ளது."
        />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="கேள்வி கேள்!விஜயிடம் கேள்வி கேள்!" />
        <meta
          property="og:description"
          content="கேள்வி கேள்!விஜயிடம் கேள்வி கேள்! த.வெ.க-விடம் கேள்வி கேள்!கேள்வி கேட்கும் உரிமை உன்னிடம் முழுமையாக உள்ளது."
        />
        <meta property="og:image" content="https://thought-box.in/og-images/askVijay.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta
          property="og:url"
          content="https://thought-box.in/blog/askVijay"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="கேள்வி கேள்!விஜயிடம் கேள்வி கேள்!" />
        <meta
          name="twitter:description"
          content="கேள்வி கேள்!விஜயிடம் கேள்வி கேள்! த.வெ.க-விடம் கேள்வி கேள்!கேள்வி கேட்கும் உரிமை உன்னிடம் முழுமையாக உள்ளது."
        />
        <meta name="twitter:image" content="https://thought-box.in/og-images/askVijay.png" />
      </Helmet>

      <article className="article-content">
        <h1 className="blog-article-title">{blog.title}</h1>
        <h2 className="blog-article-subtitle">{blog.subtitle}</h2>

        <div className="author-meta">
          <div className="author-info">
            <p className="publish-date">{blog.publishDate}</p>
          </div>
        </div>

        <div className="blog-article-body">
          <p>
            கேள்வி கேட்கும் உரிமை உன்னிடம் முழுமையாக உள்ளது.<br />
            உன் மாநிலத்தை ஆள நினைக்கும் மனிதனிடம் கேள்வி கேட்க உனக்கு உரிமை இல்லையா?
          </p>

          <div className="box">
            <p className="question">"ஏய் விஜய்! நீ ஏன் அரசியலுக்கு வருகிறாய்?" என்று கேட்கிறாய்.</p>
          </div>

          <p>
            கேள். கேட்பது உன் உரிமை.<br />
            ஆனால் அதே கேள்வியை இன்று ஆள்பவர்களிடமும், நேற்று ஆண்டவர்களிடமும்—“அரசியலில் இருந்து மக்கள் வாழ்க்கையில் என்ன மாற்றம் கொண்டு வந்தீர்கள்?” என்று கேட்க மறந்துவிடாதே.
          </p>

          <hr className="divider" />

          <div className="box">
            <p className="question">"ஏய் விஜய்! நீ ஏன் கரூருக்கு தாமதமாக வந்தாய்?" என்று கேட்கிறாய்.</p>
          </div>

          <p><span className="highlight">கேள்! நன்றாக கேள்!</span></p>

          <p>
            அதே சமயத்தில்,<br />
            எந்த நேரத்தில் பேச காவல்துறை அனுமதி கொடுத்தது?<br />
            விசாலமான இடங்கள் இருந்தும் ஏன் குறுகிய இடத்தில் அனுமதி கொடுக்கப்பட்டது?<br />
            மக்களின் பாதுகாப்புக்கு எத்தனை காவலர்கள் அனுப்பப்பட்டார்கள்?<br />
            செருப்புகள் எரியும் வீடியோ வெளியே வந்த நேரத்தில் ஏன் கலகக்காரர்கள் இருந்தார்களா என்று சந்தேகம் கூட தமிழ் பத்திரிக்கையாளர்கள் எழுப்பவில்லையே?<br />
            postmortem நடைமுறைகள் குறித்து வெளிப்படையான விளக்கம் ஏன் இல்லை? என்று கேட்க மறந்துவிடாதே
          </p>

          <hr className="divider" />

          <div className="box">
            <p className="question">"ஏய் விஜய்! நீ ஏன் கரூருக்கு சென்று இறந்தவர்களின் குடும்பத்தாரைப் பார்க்கவில்லை. ஏன் தப்பித்து ஓடினாய்?" என்று கேட்கிறாய்.</p>
          </div>

          <p>
            <span className="highlight">கேள்! கேள்!</span><br />
            ஏன் நிறுத்திவிட்டாய்? நீளவேனி! நன்றாக கேள்!
          </p>

          <p>
            விஜய் மாநிலத்தை விட்டு ஓடிவிட்டாரா?<br />
            இல்லை நாட்டை விட்டு ஓடிவிட்டாரா?
          </p>

          <p>இதற்கான வழக்கை அவர் நேர்மையாக சந்திக்கவில்லையா?</p>

          <p>
            கள்ளக்குறிச்சியில் கள்ளச்சாராயம் அருந்தி உயிரிழந்தவர்களை,<br />
            சென்னையில் ஏர் ஷோவில் உயிரிழந்தவர்களை,<br />
            தூத்துக்குடியில் சுட்டுக்கொல்லப்பட்டவர்களை,<br />
            <span className="highlight">ஆண்டவர்கள் சென்று சந்தித்தார்களா?</span> என்று கேட்க மறவாதே!
          </p>

          <hr className="divider" />

          <div className="box">
            <p className="question">"ஏய் விஜய்! நீ எப்படி ஊழலை ஒழிப்பாய்? ஊழல் கட்சி ஒன்றிலிருந்து வந்த செங்கோட்டையன் உன்னோடு இணைந்துள்ளாரே?<br />
            புலி படத்திற்காக வாங்கிய சம்பளத்தில் 1.5 கோடி வரி ஏய்ப்பு செய்ததாக குற்றச்சாட்டு எழுந்துள்ளதே? என்று கேட்கிறாய்." </p>
          </div>

          <p>
            
          </p>

          <p>
            ஆனால் மாஸ்டர் படப்பிடிப்பிலிருந்து விஜயை கூட்டிச் சென்று ஆய்வு செய்த IT Dept அப்போது clean chit கொடுத்ததே?<br />
            புலி படம் மாஸ்டர் படத்திற்கு பின் வந்ததா என்ன?
          </p>

          <p>
            விஜய் ஷாருக்கான் பிறகு இந்தியாவின் மிக உயர்ந்த வரி செலுத்தும் நடிகர்களில் ஒருவர் என்று செய்திகள் சொல்கின்றன.<br />
            <span className="highlight">அப்படியானால் அரசை ஆதரிக்கும் top superstars-களின் பெயர்கள் அந்த பட்டியலில் ஏன் பேசப்படவில்லை?</span> 
          </p>

          <p>
            செங்கோட்டையன் மீது நிலுவையில் உள்ள வழக்குகள் என்ன?<br />
            ஆளும்கட்சியில் MLA, MP மீது நிலுவையில் உள்ள வழக்குகள் என்ன?
          </p>

          <p>
            <span className="highlight">2.8 லட்சம் சம்பளம் வாங்கும் அரசியல்வாதிகளுக்கு இவ்வளவு சொத்து எப்படி வந்தது?</span> என்று கேட்க மறவாதே.
          </p>

          <hr className="divider" />

          <div className="box">
            <p className="question">"ஏய் விஜய்! நீ மக்களை அவர்கள் இருக்கும் இடத்திற்கே வந்து சந்திக்க மாட்டாயா? பத்திரிக்கையாளர்கள் சந்திப்பை ஏன் தவிர்க்கிறாய்? பயமா?" என்று கேட்கிறாய்.</p>
          </div>

          <p><span className="highlight">கேள். ஆனால் முழுமையாக கேள்!</span></p>

          <p>
            மக்கள் சந்திப்புக்கு காவல்துறை உரிய நேரத்தில் அனுமதி கொடுக்கிறதா?<br />
            அனைத்து கட்சிகளுக்கும் பாரபட்சமில்லாமல் SOP frame செய்யப்பட்டுள்ளதா?
          </p>

          <p>
            எத்தனை பத்திரிக்கையாளர்கள் விஜயின் பக்க நியாயத்தை எடுத்துரைக்கிறார்கள்?<br />
            அப்படியே பேசினாலும் அவர்கள்மீது வழக்குகள் பாயவில்லையா?
          </p>

          <p>
            பத்திரிகையாளர்கள் என்ற போர்வையில் இங்கே அவதூறு பரப்பாளர்கள் இல்லையா? என்று கேட்க மறவாதே!
          </p>

          <hr className="divider" />

          <div className="box">
            <p className="question">"ஏய் விஜய்! உன் கட்சிக்கு என்ன கொள்கை? தி.மு.க கொள்கையை ஈ அடிச்சான் காப்பி செய்திருக்கிறாய்!" என்று கேட்கிறாய்.</p>
          </div>

          <p><span className="highlight">நன்றாக கேள், தமிழகத்தின் குடிமகனே.</span></p>

          <p>
            திருமாவளவன் பிறந்த மாவட்டத்திலாவது காலணிகள் ஒழிக்கப்பட்டதா?<br />
            சிறு கிராமத்தில் வாழும் தலித்துகள் ஊரில் உள்ள கோவில்களுக்கே செல்ல முடியாது என்று உனக்கு தெரியுமா?
          </p>

          <p>சமூகநீதி பேசும் கட்சிகள் துப்பறவுப் பணியாளர்களை எப்படி நடத்தினார்கள் என்று கேட்க மறவாதே!</p>

          <hr className="divider" />

          <p>
            நீ விஜயிடம் கேட்ட கேள்விகள் உண்மையிலேயே <span className="highlight">நீயே சிந்தித்த</span> கேள்விகளா?<br />
            இல்லை <span className="highlight">"இப்படி சிந்தி" என்று திணிக்கப்பட்ட</span> கேள்விகளா?
          </p>

          <p><span className="highlight">யோசி.</span></p>

          <p>
            ஜனநாயகமும் ஜனநாயகனும் முடங்கி கிடக்கும் வேளையில்,<br />
            உன் கேள்வியிலாவது குறைந்தபட்ச ஜனநாயகத்தை காட்டி விடு!
          </p>

          <p className="final-line">
            இன்று உன் மூளையை தொலைத்தால், நாளை உன் கிட்னியைத் தொலைக்க நேரிடும்!
          </p>
        </div>
      </article>
    </BlogLayout>
  );
};

export default AskVijay;
